export enum StoryStatus {
  STORY_STATUS_UNKNOWN = 'STORY_STATUS_UNKNOWN',
  DRAFT = 'DRAFT',
  RESERVE = 'RESERVE',
  PUBLISH = 'PUBLISH',
  REJECT = 'REJECT',
}
